// extracted by mini-css-extract-plugin
export default {"root":"IconProfileCard_root__KJabg"};